<template>
    <div
        v-if="content"
        v-html="content"
    ></div>
</template>

<script>
import { generateHTML } from '@tiptap/html'
import StarterKit from '@tiptap/starter-kit'
import Link from '@tiptap/extension-link'
import TextAlign from '@tiptap/extension-text-align'

export default {
    computed: {
        content() {
            const content = this.$store.get('enrollment/selected@content')

            if (!content) {
                return null
            }

            return generateHTML(JSON.parse(content), [
                StarterKit,
                Link,
                TextAlign.configure({
                    types: ['paragraph'],
                }),
            ])
        },
    },
}
</script>
